import { tz } from "@date-fns/tz";
import { endOfDay, startOfDay } from "date-fns";
import type { IDateRange } from "../types";

export const normalizeRange = (range: IDateRange, timeZone: string): IDateRange => {
  const tzCtx = { in: tz(timeZone) };
  return {
    startDate: range.startDate ? startOfDay(range.startDate, tzCtx) : null,
    endDate: range.endDate ? endOfDay(range.endDate, tzCtx) : null,
  };
};

export const rangeDateToString = (
  range: IDateRange,
  dateFormatOptions: Intl.DateTimeFormatOptions,
  timeZone: string
) => {
  const startDate =
    range.startDate !== null ? range.startDate.toLocaleString("fr-FR", { ...dateFormatOptions, timeZone }) : "";
  const endDate =
    range.endDate !== null ? range.endDate.toLocaleString("fr-FR", { ...dateFormatOptions, timeZone }) : "";
  return { startDate, endDate };
};

export const verifyRequired = (range: IDateRange, required: { startDate: boolean; endDate: boolean }) => {
  const error = { startDate: "", endDate: "" };
  if (required.startDate && !range.startDate) {
    error.startDate = "Les dates sont obligatoires";
  }
  if (required.endDate && !range.endDate) {
    error.endDate = "Les dates sont obligatoires";
  }
  return error;
};
